// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__exFqn","inputSearch":"Search_inputSearch__fdbAh"};